<h4 class="modal-title" [ngClass]="variant != null ? 'text-' + variant : ''">
  <span class="content">
    <ng-content></ng-content>
  </span>

  <span class="default-content">
    @if (title) {
      {{ title }}
    } @else {
      {{ genericTitle | portalTranslate }}
    }
  </span>
</h4>

<button class="btn-close" (click)="emitClose()" aria-label="Close" type="button"></button>
